import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Dialog,
  DialogActions,
  DialogContent,
  withMobileDialog,
  withStyles,
  Grid,
  MenuItem,
} from '@material-ui/core'
import { toggleDialog, changeLogoUrl } from 'actions/logoManagementAndBranding'
import Button from 'components/theme/Button'
import S3Manager from 'components/S3Manager'
import Field from 'components/theme/Field'
import { update } from 'actions/data'

const updatePreferences = payload => (dispatch, getState) => {
  const preferencesAndAccountID = getState().AccountSettings.preferences
  const preferences = preferencesAndAccountID?.preferences
  const account_id = preferencesAndAccountID?.account_id

  return dispatch(
    update(
      {
        account_id,
        preferences: { ...preferences, ...payload },
      },
      'account/preference',
      '',
      'account/preference',
      'none',
    ),
  )
}

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

class LogoManagementAndBranding extends Component {
  constructor(props) {
    super(props)
    this.state = {
      s3DialogField: null,
      preferences: props.preferences,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.preferencesLength !== this.props.preferencesLength) {
      this.setState({ preferences: this.props.preferences })
    }
  }

  render() {
    const {
      fullScreen,
      open,
      toggleDialog,
      classes,
      changeLogoUrl,
      updatePreferences,
    } = this.props

    const emailColorVariables = [
      { property: 'email_color_foreground', label: 'Foreground Color' },
      { property: 'email_color_background', label: 'Background Color' },
      // {
      //   property: 'email_color_body_background',
      //   label: 'Body Background Color',
      // },
      { property: 'email_color_text_header', label: 'Header Text Color' },
      { property: 'email_color_text_paragraph', label: 'Paragraph Text Color' },
      { property: 'email_color_text_link', label: 'Link Text Color' },
      {
        property: 'email_color_button_background',
        label: 'Button Background Color',
      },
      { property: 'email_color_button_text', label: 'Button Text Color' },
    ]

    const logoVariables = [
      {
        property: 'company_logo_url_color',
        label: 'Full color',
        backgroundProperty: 'company_logo_bgcolor_color',
      },
      {
        property: 'company_logo_url_blackonwhite',
        label: 'Black logo on light background',
        backgroundProperty: 'company_logo_bgcolor_blackonwhite',
      },
      {
        property: 'company_logo_url_whiteonblack',
        label: 'White logo on dark background',
        backgroundProperty: 'company_logo_bgcolor_whiteonblack',
      },
      {
        property: 'company_logo_url_email_footer',
        label: 'Email Footer Logo',
        backgroundProperty: 'company_logo_bgcolor_email_footer',
      },
    ]

    const formColorVariables = [
      // { property: 'form_color_foreground', label: 'Foreground color' },
      { property: 'form_color_background', label: 'Background color' },
      // {
      //   property: 'form_color_body_background',
      //   label: 'Body background color',
      // },
      { property: 'form_color_text_title', label: 'Title Text Color' },
      {
        property: 'form_color_text_description',
        label: 'Description Text Color',
      },
      { property: 'form_color_text_label', label: 'Label Text Color' },
      {
        property: 'form_color_text_label_description',
        label: 'Label Description Color',
      },
      {
        property: 'form_color_button_background',
        label: 'Button Background Color',
      },
      { property: 'form_color_button_text', label: 'Button Text Color' },
    ]

    const fontOptions = [
      { value: 'inherit', label: 'inherit' },
      { value: 'Arial', label: 'Arial' },
      { value: 'Arial Black', label: 'Arial Black' },
      { value: 'Bookman', label: 'Bookman' },
      { value: 'Comic Sans MS', label: 'Comic Sans MS' },
      { value: 'Courier New', label: 'Courier New' },
      { value: 'Garamond', label: 'Garamond' },
      { value: 'Georgia', label: 'Georgia' },
      { value: 'Helvetica', label: 'Helvetica' },
      { value: 'Impact', label: 'Impact' },
      { value: 'Open Sans, sans-serif', label: 'Open Sans' },
      { value: 'Palatino', label: 'Palatino' },
      { value: 'Roboto, sans-serif', label: 'Roboto' },
      { value: 'Times New Roman', label: 'Times New Roman' },
      { value: 'Times', label: 'Times' },
      { value: 'Trebuchet MS', label: 'Trebuchet MS' },
      { value: 'Verdana', label: 'Verdana' },
    ]

    return (
      <>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={() => toggleDialog(false)}
          fullWidth
          maxWidth="lg"
          PaperProps={{
            style: {
              borderRadius: 22,
              textAlign: 'center',
              padding: 20,
            },
          }}
          classes={{ paperFullWidth: classes.paperFullWidth }}
        >
          <DialogContent>
            <div
              style={{
                textAlign: 'left',
                fontSize: 27,
                fontWeight: 'bold',
                color: '#014c94',
                marginBottom: 12,
              }}
            >
              PERSONALIZE
            </div>
            <Grid container spacing={24}>
              <Grid item lg={6} md={12}>
                <div>
                  <div style={{ fontSize: 24, textAlign: 'left' }}>
                    EMAIL THEME & BRANDING
                  </div>
                  <div
                    style={{
                      marginTop: 8,
                      marginBottom: 12,
                      fontSize: 14,
                      textAlign: 'left',
                    }}
                  >
                    Select your theme colors and font. This will change the
                    defaults for your email templates.
                  </div>
                  <Grid container spacing={8}>
                    {emailColorVariables.map(variableObj => {
                      return (
                        <Grid item lg={4} md={12} key={variableObj.property}>
                          <Field
                            value={
                              this.state.preferences?.[variableObj.property] ||
                              '#000000'
                            }
                            label={variableObj.label}
                            handleChange={(name, value) => {
                              this.setState({
                                preferences: {
                                  ...this.state.preferences,
                                  [variableObj.property]: value,
                                },
                              })
                            }}
                            property={variableObj.property}
                            variant="standard"
                            color
                          />
                        </Grid>
                      )
                    })}
                    <Grid item lg={6} md={12}>
                      <Field
                        selectTemplate={item => (
                          <MenuItem
                            key={`formsFormValue${item.value}`}
                            value={item.value}
                          >
                            <span
                              style={{ fontSize: 20, fontFamily: item.value }}
                            >
                              {item.label}
                            </span>
                          </MenuItem>
                        )}
                        value={
                          this.state.preferences?.email_font ||
                          'Roboto, sans-serif'
                        }
                        label="Font Type"
                        handleChange={(name, value) => {
                          this.setState({
                            preferences: {
                              ...this.state.preferences,
                              email_font: value,
                            },
                          })
                        }}
                        property="email_font"
                        variant="standard"
                        items={fontOptions
                          .filter(
                            option =>
                              option.label !== 'Roboto' &&
                              option.label !== 'Open Sans' &&
                              option.label !== 'inherit',
                          )
                          .map(option => ({
                            value: option.value,
                            label: option.label,
                          }))}
                        select
                      />
                    </Grid>
                  </Grid>
                </div>
                <div style={{ marginTop: 24, marginBottom: 24 }}>
                  <div style={{ fontSize: 24, textAlign: 'left' }}>
                    FORM THEME & BRANDING
                  </div>
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 14,
                      textAlign: 'left',
                      marginBottom: 12,
                    }}
                  >
                    Select your theme colors and font. This will change the
                    defaults for your forms.
                  </div>
                  <Grid container spacing={8}>
                    {formColorVariables.map(variableObj => {
                      return (
                        <Grid item lg={4} md={12} key={variableObj.property}>
                          <Field
                            value={
                              this.state.preferences?.[variableObj.property] ||
                              '#000000'
                            }
                            label={variableObj.label}
                            handleChange={(name, value) => {
                              this.setState({
                                preferences: {
                                  ...this.state.preferences,
                                  [variableObj.property]: value,
                                },
                              })
                            }}
                            property={variableObj.property}
                            variant="standard"
                            color
                          />
                        </Grid>
                      )
                    })}
                    <Grid item lg={6} md={12}>
                      <Field
                        selectTemplate={item => (
                          <MenuItem
                            key={`formsFormValue${item.value}`}
                            value={item.value}
                          >
                            <span
                              style={{ fontSize: 20, fontFamily: item.value }}
                            >
                              {item.label}
                            </span>
                          </MenuItem>
                        )}
                        value={this.state.preferences?.form_font || 'Roboto'}
                        label="Font Type"
                        handleChange={(name, value) => {
                          this.setState({
                            preferences: {
                              ...this.state.preferences,
                              form_font: value,
                            },
                          })
                        }}
                        property="form_font"
                        variant="standard"
                        items={fontOptions.map(option => ({
                          value: option.value,
                          label: option.label,
                        }))}
                        select
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item lg={6} md={12} style={{ maxWidth: '100%' }}>
                <div>
                  <div style={{ fontSize: 24, textAlign: 'left' }}>LOGO</div>
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 14,
                      textAlign: 'left',
                      marginBottom: 12,
                    }}
                  >
                    Your company logos go here. There are 4 types, and the page
                    contrast will determine which of these is used.
                  </div>
                  {logoVariables.map((variableObj, idx) => {
                    return (
                      <>
                        <div
                          style={{
                            marginTop: idx === 0 ? null : 36,
                            position: 'relative',
                            maxWidth: '100%',
                            width: 400,
                          }}
                        >
                          <div style={{ width: 'calc(100% - 80px)' }}>
                            <Field
                              value={
                                this.state.preferences?.[
                                  variableObj.property
                                ] ||
                                'https://vastreach.com/static/media/color_logo.3629eb87.png'
                              }
                              label={variableObj.label}
                              handleChange={(name, value) =>
                                this.setState({
                                  preferences: {
                                    ...this.state.preferences,
                                    [variableObj.property]: value,
                                  },
                                })
                              }
                              property={variableObj.property}
                              variant="standard"
                            />
                          </div>
                          <div
                            style={{ position: 'absolute', right: 0, top: 12 }}
                          >
                            <Button
                              onClick={() =>
                                this.setState({
                                  s3DialogField: variableObj.property,
                                })
                              }
                            >
                              BROWSE
                            </Button>
                          </div>
                        </div>
                        {this.state.preferences?.[variableObj.property] && (
                          <div
                            style={{
                              textAlign: 'left',
                              marginTop: -10,
                            }}
                          >
                            <div
                              style={{
                                display: 'inline-block',
                                backgroundColor:
                                  this.state.preferences?.[
                                    variableObj.backgroundProperty
                                  ] || '#ffffff',
                                width: '100%',
                              }}
                            >
                              <img
                                style={{ maxHeight: 56, maxWidth: '100%' }}
                                alt={variableObj.label}
                                src={
                                  this.state.preferences?.[variableObj.property]
                                }
                              />
                            </div>
                          </div>
                        )}
                        <div style={{ marginTop: 10 }}>
                          <Grid container>
                            <Grid item lg={4} md={12}>
                              <Field
                                value={
                                  this.state.preferences?.[
                                    variableObj.backgroundProperty
                                  ] ||
                                  'https://vastreach.com/static/media/color_logo.3629eb87.png'
                                }
                                label="Logo Background Color"
                                handleChange={(name, value) =>
                                  this.setState({
                                    preferences: {
                                      ...this.state.preferences,
                                      [variableObj.backgroundProperty]: value,
                                    },
                                  })
                                }
                                property={variableObj.backgroundProperty}
                                variant="standard"
                                color
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </>
                    )
                  })}
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <div style={{ height: 1, backgroundColor: 'gray' }} />
          <DialogActions
          // classes={{ root: classes.dialogActionsRoot }}
          >
            <Button
              onClick={() => {
                this.setState({
                  s3DialogField: null,
                  preferences: this.props.preferences,
                })
                toggleDialog(false)
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                toggleDialog(false)
                updatePreferences(this.state.preferences).then(() => {
                  if (
                    jwtToken &&
                    window?.ReactNativeWebView?.postMessage &&
                    this.props.company_logo_url_color
                  ) {
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify({
                        storeProfile: {
                          username: this.props.cognitoUsername,
                          company_logo_url_color:
                            this.props.company_logo_url_color,
                        },
                      }),
                    )
                  }
                })
              }}
              color="secondary"
              variant="contained"
            >
              Save and Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullScreen={fullScreen}
          onClose={() => this.setState({ s3DialogField: null })}
          fullWidth
          open={Boolean(this.state.s3DialogField)}
        >
          <S3Manager
            clickFile={url => {
              const s3DialogField = this.state.s3DialogField
              console.log('s3DialogField:', s3DialogField)

              changeLogoUrl({ name: this.state.s3DialogField, value: url })

              this.setState({
                s3DialogField: null,
                preferences: {
                  ...this.state.preferences,
                  [s3DialogField]: url,
                },
              })
            }}
          />
        </Dialog>
      </>
    )
  }
}

export default connect(
  state => ({
    open: state.logoManagementAndBranding.dialogOpen,
    company_logo_url_color:
      state.logoManagementAndBranding.company_logo_url_color,
    company_logo_url_blackonwhite:
      state.logoManagementAndBranding.company_logo_url_blackonwhite,
    company_logo_url_whiteonblack:
      state.logoManagementAndBranding.company_logo_url_whiteonblack,
    cognitoUsername:
      state?.auth?.session?.idToken?.payload?.['cognito:username'],
    preferences: state.data?.['account/preference']?.preferences || {},
    preferencesLength: Object.keys(
      state.data?.['account/preference']?.preferences || {},
    ).length,
  }),
  dispatch =>
    bindActionCreators(
      { toggleDialog, changeLogoUrl, updatePreferences },
      dispatch,
    ),
)(
  withStyles(theme => ({
    notchedOutline: {
      borderRadius: 28,
      paddingLeft: '40px !important',
    },
    paperFullWidth: { height: '100%' },
    paper: {
      border: '1px solid #adadad',
      borderRadius: 35,
    },
    dialogActionsRoot: { borderTop: '1px solid gray' },
  }))(withMobileDialog()(LogoManagementAndBranding)),
)
